<template>
  <div class="receive">
    <form class="form" @submit="checkForm">
      <div class="select-container">
        <select class="select" v-model="form.value.pid">
          <template v-for="(item, index) in professionList">
            <option v-if="index===0" :key="index" :value="item.id" selected>{{item.name}}</option>
            <option v-else :key="index" :value="item.id">{{item.name}}</option>
          </template>
        </select>
        <select class="select">
          <template v-for="(item, index) in courseList[form.value.pid]">
            <option v-if="index===0" :key="index" :value="item.id" selected>{{item.name}}</option>
            <option v-else :key="index" :value="item.id">{{item.name}}</option>
          </template>
        </select>
      </div>
      <van-cell-group class="user-input">
        <van-field
          v-model="form.value.phone"
          type="tel"
          label="手机号"
          placeholder="请输入手机号"
          :right-icon="form.icon.phone"
          :error-message="form.errors.phone"
          @focus="form.errors.phone=''"
          @input="debouncedValidPhone"
        />
        <van-field
          v-model="form.value.sms"
          label="短信验证码"
          placeholder="请输入验证码"
          :error-message="form.errors.sms"
          @focus="form.errors.sms=''"
          center
          clearable
        >
          <van-button
            v-if="!time"
            slot="button"
            size="small"
            color="#fe563e"
            @click="sendSmsCode"
          >{{isCodeSend?'重发验证码':"获取验证码"}}</van-button>
          <van-count-down v-else slot="button" :time="time" format="已获取 ss 秒" @finish="time = 0" />
        </van-field>
      </van-cell-group>
      <input class="btn-receive" type="submit" value="领取课程" />
    </form>
    <van-overlay class="overlay" :show="show" @click="show = false">
      <div class="overlay-container">
        <router-link class="overlay-wrapper" to="/download">
          <img class="overlay-wrapper-image" src="@/assets/img/receive-course.png" />
          <span class="overlay-wrapper-phone">{{form.value.phone}}</span>
        </router-link>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import smsModel from 'models/sms';
  import courseModel from 'models/course';
  import { professionList, courseList } from './config';

  const _ = require('lodash');

  export default {
    name: 'VideoReceive',
    data() {
      return {
        form: {
          value: {
            pid: '1',
            phone: '',
            sms: '',
          },
          icon: {
            phone: '',
          },
          errors: {
            phone: '',
            sms: '',
          },
        },
        isPhoneVaild: false, // 手机号是否合法
        isCodeSend: false, // 是否已经发送验证码
        isCodeVaild: false, // 是否验证成功
        time: 0, // 倒计时
        show: false, // 显示领课成功
      };
    },
    created() {
      this.professionList = professionList;
      this.courseList = courseList;
      this.debouncedValidPhone = _.debounce(this.validPhone, 500);
    },
    methods: {
      // 检查表单
      async checkForm(e) {
        e.preventDefault();
        const { phone, sms } = this.form.value;
        this.validPhone(phone);
        await this.validSms(phone, sms);

        if (this.isPhoneVaild && this.isCodeVaild) {
          this.openCourse();
        }
      },

      // 校验手机号
      validPhone(phone) {
        this.form.errors.phone = ''; // 清空错误
        // 判断手机号是否为空
        if (!phone) {
          this.isPhoneVaild = false;
          this.form.errors.phone = '请输入手机号';
          this.form.icon.phone = 'warning-o';
          return;
        }
        //  验证手机号格式
        const re = /^(1)[0-9]{10}$/;
        if (!re.test(phone)) {
          this.isPhoneVaild = false;
          this.form.errors.phone = '手机号格式有误';
          this.form.icon.phone = 'warning-o';
          return;
        }
        this.isPhoneVaild = true;
        this.form.icon.phone = 'passed';
      },

      // 校验验证码
      async validSms(phone, sms) {
        this.form.errors.sms = ''; // 清空错误
        // 判断是否发送验证码
        if (!this.isCodeSend) {
          this.isCodeVaild = false;
          this.form.errors.sms = '请先获取验证码';
          return;
        }
        // 判断 sms 是否为空
        if (!sms) {
          this.isCodeVaild = false;
          this.form.errors.sms = '请输入验证码';
          return;
        }
        // 验证
        this.showLoading();
        await smsModel.validateCode(phone, sms).then((res) => {
          this.hideLoading();
          if (res.data.code === 200) {
            this.isCodeVaild = true;
          } else {
            this.isCodeVaild = false;
            this.form.errors.sms = '验证码错误';
          }
        });
      },

      // 发送验证码
      async sendSmsCode(e) {
        e.preventDefault();
        // 手机号验证不通过，直接返回
        this.validPhone(this.form.value.phone);
        if (!this.isPhoneVaild) {
          return;
        }
        // 第一次发送验证码，获取 imageCode
        if (!this.imageCode) {
          this.showLoading();
          await smsModel.loadImageCode().then((res) => {
            this.hideLoading();
            if (res.data.code === 200) {
              this.imageCode = res.data.data;
            }
          });
        }
        // 获取验证码
        this.showLoading();
        smsModel.sendCode(this.imageCode, this.form.value.phone).then((res) => {
          this.hideLoading();
          if (res.data.code === 200) {
            this.isCodeSend = true;
            this.time = 60 * 1000;
          }
        });
      },

      // 开课
      openCourse() {
        this.showLoading();
        courseModel
          .openCourse(this.form.value.pid, this.form.value.phone)
          .then((res) => {
            this.hideLoading();
            if (res.data.code === 200) {
              this.resetForm();
              this.show = true;
            }
          });
      },

      // 重置表单
      resetForm() {
        this.form.value.sms = '';
        this.isPhoneVaild = false;
        this.isCodeSend = false;
        this.isCodeVaild = false;
        this.time = 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
@mixin form-element() {
  padding: 0 15px;
  width: 150px;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.form {
  padding: 0 20px;
  font-size: $font-size-l;
  color: #606266;

  .select-container {
    margin-bottom: 15px;
    @include flex-between();

    .select {
      @include form-element();
    }
  }

  .user-input {
    margin-bottom: 15px;
  }

  .btn-receive {
    width: 100%;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background-color: $theme-color;
    border-radius: 25px;
  }
}

.overlay {
  &-container {
    @include flex-center();
    height: 100%;
  }

  &-wrapper {
    position: relative;

    &-image {
      width: 215px;
      height: 272px;
    }

    &-phone {
      position: absolute;
      top: 120px;
      left: 50px;
    }
  }
}
</style>
